import request from '@/system/engine/request';
import config from '@/system/engine/config';
import {removeSessionStorage, setSessionStorage} from '@/system/store/sessionstorage';
import {removeTokenByName, setTokenByName} from '@/system/store/cookie';
import {getLocalStorage} from '@/system/store/localstorage';

export function checkAuth(){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'auth?language='+language,
		method: 'get'
	});
	
	var result = Promise.resolve(data);
	
	result.then(function(value){
		if(value.valid){
			setSessionStorage('wallet_list', JSON.stringify(value.user_detail.wallet_list));
			setSessionStorage('name', value.user_detail.name);
			setSessionStorage('package_name', value.user_detail.package_name);
			setSessionStorage('job_name', value.user_detail.job_name);
			setSessionStorage('date_join', value.user_detail.date_join);
			setSessionStorage('last_login', value.user_detail.last_login);
			setSessionStorage('username', value.user_detail.username);
		}
	});
	
	return Promise.resolve(data);
}

export function logout(){
	const data = request({
		url: config.url+'logout',
		method: 'get'
	});
	
	var result = Promise.resolve(data);
	
	result.then(function(value){
		if(value.valid){
			removeTokenByName('auth_sign_token');
		}
	});
	
	return Promise.resolve(data);
}

export function maintenance(){
	const data = request({
		url: config.url+'maintenance',
		method: 'get'
	});
	
	return Promise.resolve(data);
}

export function validation(postData){
	const data = request({
		url: config.url+'validation?security_password='+postData,
		method: 'get'
	});
	
	return Promise.resolve(data);
}